import {
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { forwardRef } from 'react';

import { dayjs } from '../../utils/date';
import { IDatePickerProps } from './DatePicker.types';

const DatePicker = forwardRef(function DatePickerRef(
  { value, onChange, ...props }: IDatePickerProps,
  ref?: React.Ref<HTMLDivElement> | null
) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        format="MM/DD/YY"
        sx={{
          '& .MuiInputBase-input': {
            padding: '8px 12px', // Adjust padding to make it smaller
          },
          '& .MuiIconButton-root': {
            padding: '8px', // Adjust padding to make it smaller
          },
        }}
        ref={ref}
        value={value && dayjs(value)}
        {...props}
        onChange={(...args: any[]) =>
          onChange?.(
            args[0]?.$d && dayjs(args[0]?.$d).isValid()
              ? args?.[0]?.$d?.toISOString?.()
              : null,
            ...args
          )
        }
      />
    </LocalizationProvider>
  );
});
export default DatePicker;
